import { ViewList, ViewModule } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import { writeViewMode } from '../helpers/viewModePreference';

/** Alterna entre grade de cards e tabela. */
export default function ViewModeToggle({ value, onChange, storageKey, size = 'small' }) {
    return (
        <ToggleButtonGroup
            size={size}
            color="primary"
            exclusive
            value={value}
            onChange={(_event, next) => {
                if (!next) {
                    return;
                }
                if (storageKey) {
                    writeViewMode(storageKey, next);
                }
                onChange?.(next);
            }}
            aria-label="Modo de visualização"
        >
            <ToggleButton value="cards" aria-label="Cards">
                <ViewModule fontSize="small" sx={{ mr: 0.75 }} />
                Cards
            </ToggleButton>
            <ToggleButton value="list" aria-label="Lista">
                <ViewList fontSize="small" sx={{ mr: 0.75 }} />
                Lista
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
